var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Technician Payment"},on:{"on-hide":_vm.resetFormData}},[_c('technician-payment-form',_vm._b({key:_vm.formKey,attrs:{"new-form":false},on:{"on-submit":_vm.updateTechnicianPayment,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'technician-payment-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }